<template>
  <div>
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="import"
      title="IMPORTAR LANÇAMENTO(S)"
    >
      <Import
        @success="handleSuccessImport"
        :finance_configuration_account="finance_configuration_account"
      />
    </b-modal>
    <!-- abre filtrar por período -->
    <!-- fecha filtrar por período -->
    <!-- abre filtrar por período -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="period"
      title="Filtrar por período"
    >
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <label>De</label>
          <input v-model="start_date" type="date" class="form-control" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <label>Até</label>
          <input v-model="end_date" type="date" class="form-control" />
        </div>
        <div class="col-md-12 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <v-btn x-small class="btn-cancel" @click="handleCancelFilterByPeriod"
            >CANCELAR</v-btn
          >
        </div>
        <div class="col-md-6 pt-0 pb-0 text-right">
          <v-btn
            x-small
            @click="handleFilterByPeriod"
            :disabled="loading"
            class="btn-filter m-1"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- fecha filtrar por período -->
    <!-- abre filtrar por contas -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="account"
      title="Filtrar por contas"
    >
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <div class="custom-control custom-checkbox">
            <input
              v-model="all_account"
              type="checkbox"
              class="custom-control-input"
              id="all-account"
              @change="handleAllAccount($event.target.checked)"
            />
            <label class="custom-control-label" for="all-account">TODAS</label>
          </div>
          <b-form-group>
            <b-form-checkbox
              v-for="account in finance_configuration_account"
              v-model="account_ids"
              :key="account.id"
              :value="account.id"
              name="flavour-3a"
              @input="handleAccount"
            >
              {{ account.account_nickname }}
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <v-btn x-small class="btn-cancel" @click="$bvModal.hide('account')"
            >CANCELAR</v-btn
          >
        </div>
        <div class="col-md-6 pt-0 pb-0 text-right">
          <v-btn
            x-small
            @click="handlePaginate"
            :disabled="loading"
            class="btn-filter m-1"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- fecha filtrar por contas -->
    <!-- abre mais filtros -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="filters"
      title="Mais filtros"
    >
      <div class="row">
        <div class="col-md-12">
          <Filters
            :users="users"
            :providers="providers"
            :finance_client="finance_client"
            :finance_configuration_document_types="
              finance_configuration_document_types
            "
            :finance_configuration_payment_methods="
              finance_configuration_payment_methods
            "
            :finance_configuration_category="finance_configuration_category"
            :finance_configuration_category_parents="
              finance_configuration_category_parents
            "
            :finance_configuration_profit_cost_center="
              finance_configuration_profit_cost_center
            "
            :finance_configuration_tag="finance_configuration_tag"
            :cost_types="cost_types"
            :cost_appropriations="cost_appropriations"
            :filters="{
              types_of_entries_ids,
              users_ids,
              provider_ids,
              finance_client_ids,
              finance_configuration_document_types_ids,
              finance_configuration_payment_methods_ids,
              finance_configuration_category_ids,
              finance_configuration_profit_cost_center_ids,
              finance_configuration_tag_ids,
              cost_types_ids,
              cost_appropriations_ids,
            }"
            @success="handleSuccessFilters"
            @cancel="$bvModal.hide('filters')"
          />
        </div>
      </div>
    </b-modal>
    <!-- fecha mais filtros -->
    <!-- abre pagar items selecionados -->
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="pay-selected"
      title="PAGAR/RECEBER MÚLTIPLOS LANÇAMENTOS"
    >
      <PayMultiples
        :itemsSelected="itemsPaySelected"
        :finance_configuration_account="finance_configuration_account"
        :finance_configuration_payment_methods="
          finance_configuration_payment_methods
        "
        @success="handleSuccessPay"
        @cancel="handleCancelPay"
      />
    </b-modal>
    <!-- fecha pagar items selecionados -->
    <!-- abre delete items selecionados -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="delete-selected"
      title="EXCLUIR MÚLTIPLOS LANÇAMENTOS"
    >
      <DeleteMultiples
        :itemsSelected="itemsSelected"
        @success="handleSuccessDelete"
        @cancel="handleCancelDelete"
      />
    </b-modal>
    <!-- fecha delete items selecionados -->
    <!-- abre editar items selecionados -->
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="edit-selected"
      title="EDITAR MÚLTIPLOS LANÇAMENTOS"
    >
      <EditMultiples
        :itemsSelected="itemsSelected"
        :finance_configuration_account="finance_configuration_account"
        :providers="providers"
        :finance_client="finance_client"
        :finance_configuration_document_types="
          finance_configuration_document_types
        "
        :finance_configuration_payment_methods="
          finance_configuration_payment_methods
        "
        :finance_configuration_category="finance_configuration_category"
        :finance_configuration_profit_cost_center="
          finance_configuration_profit_cost_center
        "
        :finance_configuration_tag="finance_configuration_tag"
        :cost_types="cost_types"
        :cost_appropriations="cost_appropriations"
        @success="handleSuccessEdit"
        @cancel="handleCancelEdit"
      />
    </b-modal>
    <!-- fecha editar items selecionados -->
    <!-- abre listar documentos -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="data-export-document"
      title="LISTA DE LANÇAMENTOS COM DOCUMENTOS"
    >
      <div>
        <b-overlay :show="loadingExportDocument" opacity="0.99">
          <div
            v-if="dataExportDocument.length == 0"
            class="v-clean p-5 text-center"
          >
            Sem resultados!
          </div>
          <table v-if="dataExportDocument.length > 0" class="table table-sm">
            <thead>
              <tr>
                <th>Adicionado por</th>
                <th>Tipo</th>
                <th class="text-right">Ver anexo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in dataExportDocument" :key="key">
                <td>
                  {{
                    professionalClassCouncilValue({
                      id: item.user_professional_class_council_id,
                      name: item.user_name,
                      value: item.user_professional_class_council_value,
                      cpf: item.user_cpf,
                      office: item.user_office,
                    })
                  }}
                </td>
                <td>
                  <small v-if="item.type == 'application/pdf'">PDF</small>
                  <small v-if="item.type != 'application/pdf'">Imagem</small>
                </td>
                <td class="text-right">
                  <b-modal
                    size="xl"
                    no-close-on-backdrop
                    hide-footer
                    :id="`list_document_attachments_${key}`"
                    title="ANEXO"
                  >
                    <img :src="item.attachment_url" class="d-block w-100" />
                  </b-modal>
                  <v-btn
                    v-if="item.type == 'application/pdf'"
                    class="v-primary m-1"
                    x-small
                  >
                    <a
                      class="text-white"
                      target="_blank"
                      :href="item.attachment_url"
                      >Abrir</a
                    >
                  </v-btn>
                  <v-btn
                    v-if="item.type != 'application/pdf'"
                    x-small
                    class="btn-annotation m-1"
                    @click="$bvModal.show(`list_document_attachments_${key}`)"
                  >
                    <i class="fas fa-eye mr-1"></i> VISUALIZAR
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </b-overlay>
      </div>
    </b-modal>
    <!-- fecha listar documentos -->
    <div
      v-if="loadingExport"
      style="width: 100vw; height: 100vh"
      class="d-flex align-items-center justify-content-center"
    >
      <h6 class="m-0">GERANDO DADOS PARA O EXCEL...</h6>
    </div>
    <div v-if="!loadingExport">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 back-groung-greytwo border"
      >
        <v-btn
          :disabled="loading"
          x-small
          class="menu-financial"
          :class="[type == 'TODOS' && 'v-dark']"
          @click="handleClickListType('TODOS')"
          >{{ loading ? "..." : "TODOS" }}</v-btn
        >
        <v-btn
          :disabled="loading"
          x-small
          class="menu-financial"
          :class="[type == 'A_PAGAR_RECEBER' && 'v-dark']"
          @click="handleClickListType('A_PAGAR_RECEBER')"
          >{{ loading ? "..." : "A PAGAR/A RECEBER" }}</v-btn
        >
        <v-btn
          :disabled="loading"
          x-small
          class="menu-financial"
          :class="[type == 'ATRASADOS' && 'v-dark']"
          @click="handleClickListType('ATRASADOS')"
          >{{ loading ? "..." : "ATRASADOS" }}</v-btn
        >
        <v-btn
          :disabled="loading"
          x-small
          class="menu-financial"
          :class="[type == 'CONSOLIDADOS' && 'v-dark']"
          @click="handleClickListType('CONSOLIDADOS')"
          >{{ loading ? "..." : "CONSOLIDADOS" }}</v-btn
        >
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn
            :disabled="loading"
            @click="$bvModal.show('account')"
            x-small
            class="btn-filter m-1"
            ><i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "..." : "FILTRAR POR CONTAS" }}</v-btn
          >
          <v-btn
            :disabled="loading"
            @click="$bvModal.show('filters')"
            x-small
            class="btn-filter m-1"
            ><i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "..." : "MAIS FILTROS" }}</v-btn
          >
          <v-btn
            v-if="
              types_of_entries_ids.length > 0 ||
              users_ids.length > 0 ||
              provider_ids.length > 0 ||
              finance_client_ids.length > 0 ||
              finance_configuration_document_types_ids.length > 0 ||
              finance_configuration_payment_methods_ids.length > 0 ||
              finance_configuration_category_ids.length > 0 ||
              finance_configuration_profit_cost_center_ids.length > 0 ||
              finance_configuration_tag_ids.length > 0 ||
              cost_types_ids.length > 0 ||
              cost_appropriations_ids.length > 0
            "
            @click="handleCancelFilters"
            x-small
            :disabled="loading"
            class="btn-cancel m-1"
          >
            <i class="fas fa-times mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "LIMPAR FILTRO" }}
          </v-btn>
          <v-btn
            v-if="
              permission('write', 'financial_credit') ||
              permission('write', 'financial_debit') ||
              permission('write', 'financial_transfer')
            "
            @click="$bvModal.show('import')"
            x-small
            class="btn-dateils m-1"
            ><i class="fas fa-file-import mr-2 text-twenty"></i> IMPORTAR
            LANÇAMENTO(S)</v-btn
          >
        </div>
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
          <v-btn
            :disabled="loading"
            x-small
            class="submenu-finacial"
            :class="[cash_competence == 'cash' && 'v-dark']"
            @click="handleClickCashCompetence('cash')"
          >
            {{ loading ? "..." : "CAIXA" }}</v-btn
          >
          <v-btn
            :disabled="loading"
            x-small
            class="submenu-finacial"
            :class="[cash_competence == 'competence' && 'v-dark']"
            @click="handleClickCashCompetence('competence')"
          >
            {{ loading ? "..." : "COMPETÊNCIA" }}
          </v-btn>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-right">
          <button
            :disabled="loadingExportDocument"
            v-if="!loadingExportDocument && false"
            @click="handleExportDataDocument"
            class="btn-edit m-1"
            type="button"
            style="color: #fff; padding: 3px 6px"
          >
            <i class="fas fa-file-export r-1"></i>
            {{
              loadingExportDocument
                ? "GERANDO..."
                : "LISTAR DOCUMENTOS PARA EXPORTAR"
            }}
          </button>
          <button
            :disabled="loadingExport"
            v-if="!loading && exist_data"
            @click="handleExportData"
            class="btn-edit m-1"
            type="button"
            style="color: #fff; padding: 3px 6px"
          >
            <i class="fas fa-file-export r-1"></i>
            {{ loadingExport ? "GERANDO..." : "EXPORTAR" }}
          </button>
          <button
            class="m-1 btn-print"
            type="button"
            style="padding: 3px 6px"
            v-if="!loading && exist_data"
            @click="handlePrint"
          >
            <i class="fas fa-print mr-1"></i> IMPRIMIR
          </button>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0">
          <ListFilters
            :types_of_entries_ids="types_of_entries_ids"
            :users_ids="users_ids"
            :provider_ids="provider_ids"
            :finance_client_ids="finance_client_ids"
            :finance_configuration_document_types_ids="
              finance_configuration_document_types_ids
            "
            :finance_configuration_payment_methods_ids="
              finance_configuration_payment_methods_ids
            "
            :finance_configuration_category_ids="
              finance_configuration_category_ids
            "
            :finance_configuration_profit_cost_center_ids="
              finance_configuration_profit_cost_center_ids
            "
            :finance_configuration_tag_ids="finance_configuration_tag_ids"
            :cost_types_ids="cost_types_ids"
            :cost_appropriations_ids="cost_appropriations_ids"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <hr />
        </div>
        <div class="col-md-12 pb-0 pt-0">
          <input
            type="text"
            placeholder="Pesquisar por descrição"
            v-model="search"
            class="form-control form-control-sm"
            @input="handleSearch"
          />
        </div>
        <div class="col-xl-3 col-lg-2 col-md-3 col-sm-12 col-12">
          <input
            type="text"
            placeholder="Pesquisar por R$"
            v-model="search_value"
            class="form-control form-control-sm"
            @input="handleSearchValue($event.target.value)"
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
          <div class="input-group">
            <div class="input-group-pprend">
              <v-btn
                :disabled="loading"
                @click="handlePrevMonth"
                class="v-dark noBorderRadius shadow-none"
                style="height: 31px"
                ><i class="fas fa-arrow-left"></i
              ></v-btn>
            </div>
            <input
              :disabled="loading"
              v-if="dayMonthYear == 'day'"
              v-model="month"
              type="date"
              class="form-control form-control-sm"
            />

            <tippy
              arrow
              theme="light"
              trigger="click"
              interactive
              placement="bottom"
              :enabled="!loading"
            >
              <template v-slot:trigger>
                <input
                  disabled
                  v-if="dayMonthYear == 'month'"
                  :value="moment(month).format('MM/YYYY')"
                  type="text"
                  class="form-control form-control-sm"
                />
              </template>
              <div>
                <v-date-picker
                  width="100%"
                  :disabled="loading"
                  color="#1F5A76"
                  v-model="month"
                  type="month"
                  @input="handlePaginate"
                />
              </div>
            </tippy>
            <input
              :disabled="loading"
              v-if="dayMonthYear == 'year'"
              v-model="month"
              type="text"
              class="form-control form-control-sm"
              maxlength="4"
              minlength="4"
              @input="handleInputMonthTypeYear($event.target.value)"
            />
            <div class="input-group-pprend">
              <v-btn
                :disabled="loading"
                @click="handleNextMonth"
                class="v-dark noBorderRadius shadow-none"
                style="height: 31px"
              >
                <i class="fas fa-arrow-right"></i>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-7 col-md-5 col-sm-12 col-12">
          <v-btn
            x-small
            :disabled="loading"
            class="submenu-finacial"
            style="height: 31px"
            @click="handleDayMonthYear('day')"
            :class="[dayMonthYear == 'day' && 'v-dark']"
            >Dia</v-btn
          >
          <v-btn
            x-small
            :disabled="loading"
            class="submenu-finacial"
            style="height: 31px"
            @click="handleDayMonthYear('month')"
            :class="[dayMonthYear == 'month' && 'v-dark']"
            >Mês</v-btn
          >
          <v-btn
            x-small
            :disabled="loading"
            class="submenu-finacial"
            style="height: 31px"
            @click="handleDayMonthYear('year')"
            :class="[dayMonthYear == 'year' && 'v-dark']"
            >Ano</v-btn
          >
          <v-btn
            v-if="dayMonthYear == 'day'"
            :disabled="loading"
            class="submenu-finacial v-dark"
            style="height: 31px"
            @click="handlePaginate"
            ><i class="fas fa-filter mr-1"></i> FILTRAR</v-btn
          >
          <v-btn
            small
            :disabled="loading"
            @click="handleModalFilterByPeriod"
            class="btn-filter p-2 ml-1 mr-1"
            ><i class="fas fa-filter mr-1"></i> FILTRAR POR PERÍODO</v-btn
          >
          <v-btn
            v-if="filter_by_period"
            @click="handleCancelFilterByPeriod"
            small
            :disabled="loading"
            class="btn-cancel p-2 ml-1 mr-1"
          >
            <i class="fas fa-times mr-1"></i>
            <span v-if="loading">CARREGANDO</span>
            <span v-if="!loading">LIMPAR FILTRO</span>
          </v-btn>
        </div>
        <div
          v-show="exist_data && total > 1"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <button
            v-if="btn_selected_boleto_type == 'add'"
            class="btn-selected pl-1 pr-1"
            id="btn-selected-boleto-add"
            @click="handleSelectedBoletoInBatch('add')"
          >
            <i class="fas fa-level-down-alt"></i> Selecionar todos Boletos
          </button>
          <button
            v-if="btn_selected_boleto_type == 'remove'"
            class="pl-1 pr-1 btn-selected"
            id="btn-selected-selected-boleto-remove"
            @click="handleSelectedBoletoInBatch('remove')"
          >
            <i class="fas fa-level-down-alt"></i> Desmarcar todos Boletos
          </button>

          <button
            v-if="btn_selected_type == 'add'"
            class="btn-selected pl-1 pr-1"
            id="btn-selected-add"
            @click="handleSelected('add')"
          >
            <i class="fas fa-level-down-alt"></i> Selecionar todos
          </button>
          <button
            v-if="btn_selected_type == 'remove'"
            class="pl-1 pr-1 btn-selected"
            id="btn-selected-remove"
            @click="handleSelected('remove')"
          >
            <i class="fas fa-level-down-alt"></i> Desmarcar todos
          </button>
          <button
            v-show="selected.length > 1"
            class="btn-selected btn-selected-pr ml-1 mr-1 pr-1 pl-1"
            @click="handleModalSelected('pay-selected')"
          >
            Pagar/Receber
          </button>
          <button
            x-small
            v-show="selected.length > 1"
            v-if="
              permission('edit', 'financial_credit') ||
              permission('edit', 'financial_debit') ||
              permission('edit', 'financial_transfer')
            "
            class="btn-selected btn-selected-edit ml-1 mr-1 pr-1 pl-1"
            @click="handleModalSelected('edit-selected')"
          >
            Editar
          </button>
          <button
            x-small
            v-show="selected.length > 1"
            v-if="
              permission('remove', 'financial_credit') ||
              permission('remove', 'financial_debit') ||
              permission('remove', 'financial_transfer')
            "
            class="btn-selected btn-selected-delete ml-1 mr-1 pr-1 pl-1"
            @click="handleModalSelected('delete-selected')"
          >
            Excluir
          </button>

          <!-- Luiz verificar as permissões -->
          <div v-if="permission('write', 'boleto')">
            <button
              x-small
              v-show="selectedBoletosInBatch.length > 1"
              class="btn-selected btn-selected-edit ml-1 mr-1 pr-1 pl-1"
              @click="showBoletoInBatchModal = true"
            >
              Gerar boletos em Lote
            </button>

            <GenerateBoletoInBatch
              :visible="showBoletoInBatchModal"
              :itens="selectedBoletosInBatch"
              @close="modalCloseBoletoInBatch()"
              @gerado="paginate"
              @input="showBoletoInBatchModal = $event"
            />
          </div>
        </div>
      </div>
      <ErrorsMessages :errors="errors" />
      <b-overlay :show="loading" opacity="0.99">
        <div v-show="data.length > 0 && total > 0">
          <v-data-table
            class="v-data-table-no-border v-data-table-finance"
            :headers="headers"
            :items="data"
            item-key="id"
            :options.sync="options"
            :server-items-length="total"
            :footer-props="{
              'items-per-page-options': [50],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <!-- @click:row="handleClickRowTable" -->
            <!-- <template v-slot:[`item.data-table-select`]="{ item }">
          <div v-if="item.id"></div>
        </template> -->
            <template v-slot:[`item.BoletoBatch`]="{ item }">
              <b-form-checkbox
                v-if="item.id && item.finance_client_id && item.boleto == 0"
                :id="`second-boleto-${item.id}`"
                :name="`second-boleto-${item.id}`"
                :value="item.id"
                v-model="selectedBoletosInBatchIds"
              />
            </template>

            <template v-slot:[`item.date`]="{ item }">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-if="item.id && item.boleto == 0"
                  :disabled="item.finance_client_resident_id ? true : false"
                  :id="`checkbox-${item.id}`"
                  :name="`checkbox-${item.id}`"
                  :value="item.id"
                  @change="handleChangeSelected($event, item)"
                />
                <!-- <div class="text-twelve" @click="handleClickRowTable(item)">
              {{ item.date }}
            </div> -->
                <span v-if="item.view_date" class="text-twelve">
                  <span class="weight-600">
                    {{ moment(item.view_date).format("DD") }}
                  </span>
                  <span class="text-capitalize">{{
                    moment(item.view_date).format("MMM")
                  }}</span>
                </span>
                <v-btn
                  x-small
                  v-if="item.totalAnexos > 0"
                  @click="$bvModal.show(`list_attachments_${item.id}`)"
                  class="ml-2 v-primary"
                >
                  <i class="fas fa-paperclip"></i>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.categories`]="{ item }">
              <div v-if="item.type == 'TRANSFERENCIA'">
                <small
                  class="text-eleven noBorderRadius v-primary pl-2 pr-2 pt-1 pb-1 c-white"
                  @click="handleClickRowTable(item)"
                >
                  TRANSFERÊNCIA
                </small>
              </div>
              <div
                v-if="
                  item.type == 'CONTAS_A_PAGAR' ||
                  item.type == 'CONTAS_A_RECEBER'
                "
                @click="handleClickRowTable(item)"
              >
                <v-tooltip
                  v-if="item.categories.length == 1"
                  bottom
                  max-width="300"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <span
                        :style="`background-color: ${
                          item.finance_configuration_category_color
                            ? item.finance_configuration_category_color
                            : '#999'
                        }`"
                        :class="[
                          'pl-1 pr-1 m-0 worksansr text-twelve',
                          String(
                            item.finance_configuration_category_color
                          ).toUpperCase() == '#FFFFFF'
                            ? ''
                            : 'c-white',
                        ]"
                      >
                        {{
                          handleTextByLimit(
                            item.finance_configuration_category_name
                          )
                        }}
                      </span>
                    </div>
                  </template>
                  <span>
                    {{ item.finance_configuration_category_name }}
                  </span>
                </v-tooltip>

                <div
                  v-if="item.categories.length > 1"
                  class="d-flex align-items-center"
                >
                  <v-tooltip
                    v-for="(category, key) in item.categories"
                    bottom
                    max-width="300"
                    :key="key"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <span
                          :style="`background-color: ${
                            category.color ? category.color : '#999'
                          }`"
                          :class="[
                            'mr-1 pl-1 pr-1 m-0 worksansr text-fifteen',
                            String(category.color).toUpperCase() == '#FFFFFF'
                              ? ''
                              : 'c-white',
                          ]"
                        >
                          {{ String(category.name).substring(0, 1) }}
                          <!-- {{
                      handleTextByLimit(
                        category.name
                      )
                    }} -->
                        </span>
                      </div>
                    </template>
                    <span>
                      {{ category.name }}
                    </span>
                  </v-tooltip>
                </div>
              </div>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <div
                class="row m-0"
                v-if="
                  item.type == 'previous_balance' ||
                  item.type == 'opening_balance'
                "
                @click="handleClickRowTable(item)"
              >
                <div
                  :class="[
                    'd-flex align-items-center p-0 text-thirteen',
                    item.type == 'previous_balance' && 'col-md-12',
                    item.type == 'opening_balance' && 'col-md-12',
                  ]"
                >
                  {{ item.description }}
                </div>
                <div
                  :class="[
                    'p-0',
                    item.type == 'previous_balance' && 'col-md-12 pt-0 pb-0',
                    item.type == 'opening_balance' && 'col-md-12',
                  ]"
                >
                  <p
                    class="m-0 worksansr text-thirteen"
                    v-for="(account, account_key) in item.accounts"
                    :key="`${account.account_nickname}-${account_key}`"
                  >
                    [{{ account.account_nickname }}]
                    <span class="c-success" v-if="account.account_status == 1">
                      {{ formatMoney(String(account.balance_date)) }}
                    </span>
                    <span class="c-danger" v-if="account.account_status == 0">
                      -{{ formatMoney(String(account.balance_date)) }}
                    </span>
                  </p>
                </div>
              </div>
              <span
                v-if="item.is_purchase == 1"
                class="worksansr p-1 m-0 v-warning noBorderRadius text-ten"
              >
                GERADO PELA COMPRA
              </span>
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <div
                      v-if="
                        item.type != 'previous_balance' &&
                        item.type != 'opening_balance'
                      "
                      @click="handleClickRowTable(item)"
                    >
                      <p class="m-0 limit-text worksansr text-twelve">
                        {{
                          item.finance_launch_bills_to_pay_installments_items
                            .length > 1
                            ? `(${item.finance_launch_bills_to_pay_installments_items.length})`
                            : ""
                        }}
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </template>
                <span v-if="item.id">
                  <div class="row m-0">
                    <div
                      class="col-md-12 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="
                        item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER'
                      "
                    >
                      <b>Conta</b>
                      <small>
                        {{ item.finance_configuration_account_name }}
                      </small>
                    </div>
                    <div
                      class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="
                        item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER'
                      "
                    >
                      <b>Competência</b>
                      <small>
                        {{ moment(item.competence).format("DD/MM/YYYY") }}
                      </small>
                    </div>
                    <div
                      class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="
                        item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER'
                      "
                    >
                      <b>Vencimento</b>
                      <small>{{
                        moment(item.due_date).format("DD/MM/YYYY")
                      }}</small>
                    </div>
                    <div
                      class="col-md-8 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <b>Conta origem</b>
                      <small>{{ item.origin_account_name }}</small>
                    </div>
                    <div
                      class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <b>Valor</b>
                      <small>- {{ formatMoney(String(item.value)) }}</small>
                    </div>
                    <div
                      class="col-md-8 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <b>Conta destino</b>
                      <small>{{ item.destination_account_name }}</small>
                    </div>
                    <div
                      class="col-md-4 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <b>Valor</b>
                      <small>{{ formatMoney(String(item.value)) }}</small>
                    </div>
                    <div
                      class="col-md-12 pt-0 pb-0 d-flex flex-column text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <b>Data</b>
                      <small>
                        {{ moment(item.created_at).format("DD/MM/YYYY") }}
                      </small>
                    </div>
                    <div class="col-md-12 p-0"></div>
                    <div class="col-md-4 pt-0 pb-0 text-twelve">
                      <b>Descrição</b>
                    </div>
                    <div
                      class="col-md-2 pt-0 pb-0 text-twelve"
                      v-if="item.type != 'TRANSFERENCIA'"
                    >
                      <b>Valor</b>
                    </div>
                    <div
                      class="col-md-2 pt-0 pb-0 text-twelve"
                      v-if="item.type != 'TRANSFERENCIA'"
                    >
                      <b>Categoria</b>
                    </div>
                    <div
                      class="col-md-4 pt-0 pb-0 text-twelve"
                      v-if="item.type != 'TRANSFERENCIA'"
                    >
                      <b>Centro de custo/lucro</b>
                    </div>

                    <div class="co-md-12 p-0"></div>

                    <div
                      class="col-md-12 pt-0 pb-0 text-twelve"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <small>{{ item.description }}</small>
                    </div>
                  </div>
                  <div
                    class="row m-0"
                    v-show="item.type != 'TRANSFERENCIA'"
                    v-for="(
                      finance_launch_bills_to_pay_installments_item, key
                    ) in item.finance_launch_bills_to_pay_installments_items"
                    :key="key"
                  >
                    <div class="col-md-4 pt-0 pb-0 text-twelve">
                      <small>{{
                        finance_launch_bills_to_pay_installments_item.description
                      }}</small>
                    </div>
                    <div class="col-md-2 pt-0 pb-0 text-twelve">
                      <small>{{
                        formatMoney(
                          String(
                            finance_launch_bills_to_pay_installments_item.value
                          )
                        )
                      }}</small>
                    </div>
                    <div class="col-md-2 pt-0 pb-0 text-twelve">
                      <small>{{
                        handleTextByLimit(
                          finance_launch_bills_to_pay_installments_item.finance_configuration_category_name,
                          5
                        )
                      }}</small>
                    </div>
                    <div class="col-md-4 pt-0 pb-0 text-twelve">
                      <small>{{
                        finance_launch_bills_to_pay_installments_item.finance_configuration_profit_cost_center_description
                      }}</small>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div
                      class="col-md-12 pt-0 pb-0 d-flex align-items-center justify-content-end text-twelve"
                    >
                      <small class="mr-2">Criado em:</small>
                      <small class="mr-2">
                        {{
                          moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                        }}
                      </small>
                      <small class="mr-2">por:</small>
                      <small>
                        {{ item.user_name }}
                      </small>
                    </div>
                    <div
                      class="col-md-12 pt-0 pb-0 d-flex align-items-center justify-content-end text-twelve"
                    >
                      <small class="mr-2">Atualizado em:</small>
                      <small>
                        {{
                          moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss")
                        }}
                      </small>
                    </div>
                  </div>
                </span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.profit_cost_center`]="{ item }">
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <p
                      class="m-0 limit-text worksansr"
                      @click="handleClickRowTable(item)"
                    >
                      {{
                        item.finance_configuration_profit_cost_center_description
                      }}
                    </p>
                  </div>
                </template>
                <span>
                  {{
                    item.finance_configuration_profit_cost_center_description
                  }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.client_provider`]="{ item }">
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <p
                      class="m-0 limit-text worksansr text-twelve"
                      @click="handleClickRowTable(item)"
                    >
                      {{
                        item.spent_or_gain == "DEBITO"
                          ? item.provider_company_name
                          : item.finance_client_name
                      }}
                    </p>
                  </div>
                </template>
                <span>
                  {{
                    item.spent_or_gain == "DEBITO"
                      ? item.provider_company_name
                      : item.finance_client_name
                  }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.value`]="{ item }">
              <div
                style="min-width: 100px !important"
                v-if="
                  item.type != 'previous_balance' &&
                  item.type != 'opening_balance'
                "
                :class="[`c-${item.color}`, 'text-right']"
              >
                {{ item.color == "danger" ? "-" : "" }}
                {{ formatMoney(String(item.value).replace("-", "")) }}
              </div>
              <div
                v-if="
                  item.type == 'previous_balance' ||
                  item.type == 'opening_balance'
                "
                :class="[
                  item.value > 0 ? 'c-success' : 'c-danger',
                  'text-right',
                ]"
              >
                {{ formatMoney(String(item.value)) }}
              </div>
            </template>
            <template v-slot:[`item.is_repeat`]="{ item }">
              <div v-if="item.is_repeat == 'MAIS_DE_UMA_VEZ'" class="d-flex">
                <small class="v-dark noBorderRadius text-nine">
                  {{ item.index_key }}/{{ item.how_many_times }}
                </small>
                <small class="v-clean noBorderRadius text-nine">
                  {{ item.periodicity }}
                </small>
              </div>
              <div v-if="item.is_repeat == 'SEMPRE'">
                <v-tooltip bottom max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <p class="m-0 worksansr">
                        <small class="v-dark noBorderRadius text-nine"
                          ><i class="fas fa-sync-alt"></i
                        ></small>
                        <small class="v-clean noBorderRadius text-nine">
                          {{ item.periodicity }}
                        </small>
                      </p>
                    </div>
                  </template>
                  <span> Número da repetição: {{ item.index_key }} </span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.balance`]="{ item }">
              <div
                :class="[
                  'text-right',
                  item.balance > 0 && 'c-success',
                  item.balance <= 0 && 'c-danger',
                ]"
              >
                {{ formatMoney(String(item.balance)) }}
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div
                v-if="item.type == 'TRANSFERENCIA'"
                class="c-primary text-right text-thirteen"
              >
                <small>Transferido <i class="fas fa-random"></i></small>
              </div>
              <div
                v-if="
                  item.type == 'CONTAS_A_PAGAR' ||
                  item.type == 'CONTAS_A_RECEBER'
                "
              >
                <b-modal
                  scrollable
                  size="lg"
                  no-close-on-backdrop
                  hide-footer
                  hide-header-close
                  :id="`action-pay-${item.id}`"
                  title="PAGAR ESTE AGENDAMENTO"
                >
                  <b-overlay :show="loadingActionToPay" opacity="0.99">
                    <SpentPay
                      :data="{ ...item, items }"
                      :providers="providers"
                      :finance_client="finance_client"
                      :finance_configuration_account="
                        finance_configuration_account
                      "
                      :finance_configuration_document_types="
                        finance_configuration_document_types
                      "
                      :finance_configuration_payment_methods="
                        finance_configuration_payment_methods
                      "
                      :finance_configuration_category="
                        finance_configuration_category
                      "
                      :finance_configuration_profit_cost_center="
                        finance_configuration_profit_cost_center
                      "
                      :finance_configuration_tag="finance_configuration_tag"
                      :cost_types="cost_types"
                      :cost_appropriations="cost_appropriations"
                      @cancel="handleCancelSpentPay(`action-pay-${item.id}`)"
                      @success="handleSuccessSpentPay(`action-pay-${item.id}`)"
                    />
                  </b-overlay>
                </b-modal>
                <div class="text-right">
                  <v-btn
                    :disabled="loadingActionToPay"
                    class="mr-1 btn-reordenar-save"
                    x-small
                    v-if="
                      (item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER') &&
                      item.id &&
                      item.is_paid == 0 &&
                      item.is_resident
                    "
                    @click="handleModalPendingBilling(item)"
                  >
                    <i class="fas fa-clock mr-1"></i>
                    FAT. PEND.
                  </v-btn>
                  <v-btn
                    :disabled="loadingActionToPay"
                    :class="[
                      !item.late_payment && 'btn-edit',
                      item.late_payment && 'btn-i',
                    ]"
                    x-small
                    v-if="item.is_paid == 0"
                    @click="handleModalToPay(item)"
                  >
                    <i class="fas fa-clock mr-1"></i>
                    {{ item.type == "CONTAS_A_PAGAR" ? "PAGAR" : "RECEBER" }}
                  </v-btn>
                  <v-btn x-small disabled v-if="item.is_paid == 1">
                    <i class="fas fa-check mr-1"></i
                    >{{ item.type == "CONTAS_A_PAGAR" ? "PAGO" : "RECEBIDO" }}
                  </v-btn>
                </div>
              </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <b-modal
                size="lg"
                no-close-on-backdrop
                hide-footer
                :id="`list_attachments_${item.id}`"
                title="ANEXOS"
              >
                <Attachments
                  :finance_launch_bills_to_pay_installments_id="item.id"
                  @success="handleSuccessAttachments(item.id)"
                />
              </b-modal>
              <b-modal
                scrollable
                size="lg"
                no-close-on-backdrop
                hide-footer
                :id="`details-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                :title="`${
                  item.type == 'TRANSFERENCIA' ? 'DETALHES' : 'ITENS'
                }`"
              >
                <b-overlay :show="loadingDetails" opacity="0.99">
                  <SpentDetails
                    :data="{ ...item, items }"
                    :providers="providers"
                    :finance_client="finance_client"
                    :finance_configuration_account="
                      finance_configuration_account
                    "
                    :finance_configuration_document_types="
                      finance_configuration_document_types
                    "
                    :finance_configuration_payment_methods="
                      finance_configuration_payment_methods
                    "
                    :finance_configuration_category="
                      finance_configuration_category
                    "
                    :finance_configuration_profit_cost_center="
                      finance_configuration_profit_cost_center
                    "
                    :finance_configuration_tag="finance_configuration_tag"
                    :cost_types="cost_types"
                    :cost_appropriations="cost_appropriations"
                  />
                </b-overlay>
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`edit-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="EDITAR"
              >
                <b-overlay :show="loadingEdit" opacity="0.99">
                  <SpentEdit
                    :data="{ ...item, items }"
                    :providers="providers"
                    :finance_client="finance_client"
                    :finance_configuration_account="
                      finance_configuration_account
                    "
                    :finance_configuration_document_types="
                      finance_configuration_document_types
                    "
                    :finance_configuration_payment_methods="
                      finance_configuration_payment_methods
                    "
                    :finance_configuration_category="
                      finance_configuration_category
                    "
                    :finance_configuration_profit_cost_center="
                      finance_configuration_profit_cost_center
                    "
                    :finance_configuration_tag="finance_configuration_tag"
                    :cost_types="cost_types"
                    :cost_appropriations="cost_appropriations"
                    @cancel="
                      $bvModal.hide(
                        `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
                      )
                    "
                    @success="handleSuccessSpentEdit(item)"
                    @successDelete="handleSuccessDeleteSpentEdit(item)"
                    @postPendingBilling="handlePostPendingBilling(item)"
                    @idCreate="handleIdCreate"
                  />
                </b-overlay>
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`pending-billing-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="FATURAMENTO"
              >
                <b-overlay :show="loadingEdit" opacity="0.99">
                  <PendingBilling
                    :data="{ ...item, items }"
                    :providers="providers"
                    :finance_client="finance_client"
                    :finance_configuration_account="
                      finance_configuration_account
                    "
                    :finance_configuration_document_types="
                      finance_configuration_document_types
                    "
                    :finance_configuration_payment_methods="
                      finance_configuration_payment_methods
                    "
                    :finance_configuration_category="
                      finance_configuration_category
                    "
                    :finance_configuration_profit_cost_center="
                      finance_configuration_profit_cost_center
                    "
                    :finance_configuration_tag="finance_configuration_tag"
                    :cost_types="cost_types"
                    :cost_appropriations="cost_appropriations"
                    @cancel="
                      $bvModal.hide(
                        `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
                      )
                    "
                    @success="handleSuccessPendingBilling(item)"
                    @postPendingBilling="handlePostPendingBilling(item)"
                  />
                </b-overlay>
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`edit-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="EDITAR TRANSFERÊNCIA"
              >
                <b-overlay :show="loadingEdit" opacity="0.99">
                  <SpentEditTransfer
                    :data="{ ...item, items }"
                    :finance_configuration_account="
                      finance_configuration_account
                    "
                    :finance_configuration_profit_cost_center="
                      finance_configuration_profit_cost_center
                    "
                    @cancel="
                      $bvModal.hide(
                        `edit-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
                      )
                    "
                    @success="handleSuccessSpentEditTransfer(item)"
                  />
                </b-overlay>
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`delete-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="EXCLUIR"
              >
                <SpentDelete
                  :data="{ ...item, items }"
                  :providers="providers"
                  :finance_client="finance_client"
                  :finance_configuration_account="finance_configuration_account"
                  :finance_configuration_document_types="
                    finance_configuration_document_types
                  "
                  :finance_configuration_payment_methods="
                    finance_configuration_payment_methods
                  "
                  :finance_configuration_category="
                    finance_configuration_category
                  "
                  :finance_configuration_profit_cost_center="
                    finance_configuration_profit_cost_center
                  "
                  :finance_configuration_tag="finance_configuration_tag"
                  :cost_types="cost_types"
                  :cost_appropriations="cost_appropriations"
                  @cancel="
                    $bvModal.hide(
                      `delete-${item.finance_launch_bills_to_pay_id}-${item.id}`
                    )
                  "
                  @success="handleSuccessSpentDelete(item)"
                />
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`receipt-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="RECIBO"
              >
                <SpentReceipt
                  :data="{ ...item, items }"
                  :providers="providers"
                  :finance_client="finance_client"
                  :finance_configuration_account="finance_configuration_account"
                  :finance_configuration_document_types="
                    finance_configuration_document_types
                  "
                  :finance_configuration_payment_methods="
                    finance_configuration_payment_methods
                  "
                  :finance_configuration_category="
                    finance_configuration_category
                  "
                  :finance_configuration_profit_cost_center="
                    finance_configuration_profit_cost_center
                  "
                  :finance_configuration_tag="finance_configuration_tag"
                  :cost_types="cost_types"
                  :cost_appropriations="cost_appropriations"
                  @cancel="
                    $bvModal.hide(
                      `receipt-${item.finance_launch_bills_to_pay_id}-${item.id}`
                    )
                  "
                  @success="handleSuccessSpentReceipt(item)"
                />
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`duplicate-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="DUPLICAR LANÇAMENTO"
              >
                <SpentDuplicate
                  :data="{ ...item, items }"
                  :providers="providers"
                  :finance_client="finance_client"
                  :finance_configuration_account="finance_configuration_account"
                  :finance_configuration_document_types="
                    finance_configuration_document_types
                  "
                  :finance_configuration_payment_methods="
                    finance_configuration_payment_methods
                  "
                  :finance_configuration_category="
                    finance_configuration_category
                  "
                  :finance_configuration_profit_cost_center="
                    finance_configuration_profit_cost_center
                  "
                  :finance_configuration_tag="finance_configuration_tag"
                  :cost_types="cost_types"
                  :cost_appropriations="cost_appropriations"
                  @cancel="
                    $bvModal.hide(
                      `duplicate-${item.finance_launch_bills_to_pay_id}-${item.id}`
                    )
                  "
                  @success="handleSuccessSpentDuplicate(item)"
                />
              </b-modal>
              <b-modal
                scrollable
                size="xl"
                no-close-on-backdrop
                hide-footer
                :id="`duplicate-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`"
                title="DUPLICAR TRANSFERÊNCIA"
              >
                <SpentDuplicateTransfer
                  :data="{ ...item, items }"
                  :finance_configuration_account="finance_configuration_account"
                  :finance_configuration_profit_cost_center="
                    finance_configuration_profit_cost_center
                  "
                  @cancel="
                    $bvModal.hide(
                      `duplicate-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
                    )
                  "
                  @success="handleSuccessSpentDuplicateTransfer(item)"
                />
              </b-modal>
              <b-modal
                size="sm"
                no-close-on-backdrop
                hide-footer
                :id="`action-${item.id}`"
                title="AÇÕES"
              >
                <b-overlay :show="loadingActions" opacity="0.99">
                  <div class="row text-center">
                    <div
                      class="col-md-12 pt-0"
                      v-if="
                        item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER'
                      "
                    >
                      <v-btn
                        x-small
                        class="btn-edit btn-block"
                        @click="handleEdit(item)"
                        ><i class="fas fa-edit mr-1"></i>Editar</v-btn
                      >
                    </div>
                    <div
                      class="col-md-12 pt-0"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <v-btn
                        x-small
                        class="btn-edit btn-block"
                        @click="handleEditTransfer(item)"
                        ><i class="fas fa-edit mr-1"></i>Editar</v-btn
                      >
                    </div>
                    <div class="col-md-12" v-if="!item.existResidentAccount">
                      <v-btn
                        x-small
                        class="btn-delete btn-block"
                        @click="handleDelete(item)"
                        ><i class="fas fa-trash mr-1"></i>Excluir</v-btn
                      >
                    </div>
                    <div
                      class="col-md-12"
                      v-if="item.resident_has_accommodation_item_id"
                    >
                      <DeleteHosting :item="item" @success="paginate" />
                    </div>
                    <div class="col-md-12" v-if="item.resident_has_service_id">
                      <DeleteService :item="item" @success="paginate" />
                    </div>
                    <div class="col-md-12" v-if="item.stock_sale_id">
                      <DeleteStockSale :item="item" @success="paginate" />
                    </div>
                    <div class="col-md-12">
                      <v-btn
                        x-small
                        class="btn-save btn-block"
                        @click="handleReceipt(item)"
                        ><i class="fas fa-file-pdf mr-1"></i>Recibo</v-btn
                      >
                    </div>
                    <div
                      class="col-md-12 pb-0"
                      v-if="
                        item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER'
                      "
                    >
                      <v-btn
                        v-if="
                          !item.resident_has_accommodation_item_id &&
                          !item.resident_has_service_id &&
                          !item.stock_sale_id
                        "
                        x-small
                        class="btn-edit btn-block"
                        @click="handleDuplicate(item)"
                        ><i class="fas fa-copy mr-1"></i>Duplicar
                        lançamento</v-btn
                      >
                    </div>
                    <div
                      class="col-md-12 pb-0"
                      v-if="item.type == 'TRANSFERENCIA'"
                    >
                      <v-btn
                        x-small
                        class="btn-edit btn-block"
                        @click="handleDuplicateTransfer(item)"
                        ><i class="fas fa-copy mr-1"></i>Duplicar
                        transferência</v-btn
                      >
                    </div>
                  </div>
                </b-overlay>
              </b-modal>
              <!-- <div class="d-flex align-items-center justify-content-end">
            <v-btn
              :disabled="loadingDetails"
              v-if="item.id"
              x-small
              class="btn-edit m-1"
              @click="handleModalDetails(item)"
            >
              <i class="fas fa-eye mr-1"></i>
              {{ item.type == "TRANSFERENCIA" ? "DETALHES" : "ITENS" }}
            </v-btn>
            <v-btn
              :disabled="loadingActions"
              v-if="item.id"
              x-small
              class="btn-reordenar-save"
              @click="handleModalActions(item)"
            >
              <i class="fas fa-edit mr-1"></i>
              {{ loadingActions ? "..." : "AÇÕES" }}
            </v-btn>
          </div> -->
              <div class="d-flex">
                <v-speed-dial
                  v-if="item.id"
                  :id="item.id"
                  v-model="item.fab"
                  transition="slide-x-reverse-transition"
                  direction="left"
                >
                  <template v-slot:activator>
                    <v-btn
                      :disabled="loadingActions"
                      x-small
                      class="btn-reordenar-save mr-1"
                      :id="item.id"
                      v-model="item.fab"
                      @click="handleModalOption(item)"
                    >
                      <v-icon small v-if="item.fab"> mdi-close </v-icon>
                      <v-icon small v-else> mdi-dots-vertical </v-icon>
                    </v-btn>
                  </template>
                  <v-btn
                    x-small
                    :disabled="loadingActions"
                    v-if="
                      item.type == 'CONTAS_A_PAGAR' ||
                      (item.type == 'CONTAS_A_RECEBER' &&
                        (permission('edit', 'financial_credit') ||
                          permission('edit', 'financial_debit') ||
                          permission('edit', 'financial_transfer')))
                    "
                    class="btn-edit"
                    @click="handleEdit(item)"
                    ><i class="fas fa-edit mr-1"></i>Editar</v-btn
                  >
                  <v-btn
                    :disabled="loadingActions"
                    v-if="
                      item.type == 'TRANSFERENCIA' &&
                      (permission('edit', 'financial_credit') ||
                        permission('edit', 'financial_debit') ||
                        permission('edit', 'financial_transfer'))
                    "
                    x-small
                    class="btn-edit"
                    @click="handleEditTransfer(item)"
                    ><i class="fas fa-edit mr-1"></i>Editar</v-btn
                  >
                  <v-btn
                    x-small
                    :disabled="loadingActions"
                    class="btn-save"
                    @click="handleReceipt(item)"
                    ><i class="fas fa-file-pdf mr-1"></i>Recibo</v-btn
                  >
                  <v-btn
                    x-small
                    :disabled="loadingActions"
                    v-if="
                      (item.type == 'CONTAS_A_PAGAR' ||
                        item.type == 'CONTAS_A_RECEBER') &&
                      !item.resident_has_accommodation_item_id &&
                      !item.resident_has_service_id &&
                      !item.stock_sale_id &&
                      (permission('write', 'financial_credit') ||
                        permission('write', 'financial_debit') ||
                        permission('write', 'financial_transfer'))
                    "
                    class="btn-edit"
                    @click="handleDuplicate(item)"
                    ><i class="fas fa-copy mr-1"></i>Duplicar lançamento</v-btn
                  >
                  <v-btn
                    x-small
                    :disabled="loadingActions"
                    v-if="item.type == 'TRANSFERENCIA'"
                    class="btn-edit"
                    @click="handleDuplicateTransfer(item)"
                    ><i class="fas fa-copy mr-1"></i>Duplicar
                    transferência</v-btn
                  >
                  <v-btn
                    :disabled="loadingDetails"
                    v-if="item.id"
                    x-small
                    class="btn-edit m-1"
                    @click="handleModalDetails(item)"
                  >
                    <i class="fas fa-eye mr-1"></i>
                    {{ item.type == "TRANSFERENCIA" ? "DETALHES" : "ITENS" }}
                  </v-btn>
                </v-speed-dial>

                <BoletoCloud
                  @gerado="paginate"
                  v-if="permission('write', 'boleto')"
                  :item="item"
                />

                <v-btn
                  x-small
                  :disabled="loadingActions"
                  v-if="
                    item.id &&
                    !item.existResidentAccount &&
                    (permission('remove', 'financial_credit') ||
                      permission('remove', 'financial_debit') ||
                      permission('remove', 'financial_transfer'))
                  "
                  class="btn-delete"
                  @click="handleModalDelete(item)"
                  ><i class="fas fa-trash"></i
                ></v-btn>
                <DeleteHosting
                  :disabled="loadingActions"
                  v-if="
                    item.resident_has_accommodation_item_id &&
                    (permission('remove', 'financial_credit') ||
                      permission('remove', 'financial_debit') ||
                      permission('remove', 'financial_transfer'))
                  "
                  :item="item"
                  @success="paginate"
                  @errors="handleErrorDelete"
                />
                <DeleteService
                  :disabled="loadingActions"
                  v-if="
                    item.resident_has_service_id &&
                    (permission('remove', 'financial_credit') ||
                      permission('remove', 'financial_debit') ||
                      permission('remove', 'financial_transfer'))
                  "
                  :item="item"
                  @success="paginate"
                  @errors="handleErrorDelete"
                />
                <DeleteStockSale
                  :disabled="loadingActions"
                  v-if="
                    item.stock_sale_id &&
                    (permission('remove', 'financial_credit') ||
                      permission('remove', 'financial_debit') ||
                      permission('remove', 'financial_transfer'))
                  "
                  :item="item"
                  @success="paginate"
                  @errors="handleErrorDelete"
                />
              </div>
            </template>
          </v-data-table>
        </div>
        <div
          v-if="total == 0 || period_result == 0"
          class="p-2 text-center warning-alert"
        >
          Não existem lançamentos para esta filtragem.
        </div>
        <hr />
        <div class="row mb-5">
          <div
            class="col-md-2 pt-0 pb-0 d-flex align-items-center justify-content-center"
          >
            Resumo do período
          </div>
          <div class="col-md-10 pt-0 pb-0">
            <div class="row">
              <div class="col-md-12 pt-0 pb-0 border-bottom">
                <div class="row d-flex align-items-center">
                  <div class="col-md-4">
                    <p class="m-0 worksansr">Saldo anterior</p>
                  </div>
                  <div class="col-md-6"></div>
                  <div class="col-md-2 text-right">
                    <p
                      :class="[
                        'm-0',
                        parseFloat(previous_balance) >= 0
                          ? 'c-success'
                          : 'c-danger',
                      ]"
                    >
                      {{ formatMoney(String(previous_balance)) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <div class="row d-flex align-items-center">
                  <div class="col-md-4">
                    <p class="m-0 worksansr">Total de ganhos</p>
                  </div>
                  <div class="col-md-6">
                    <b-progress
                      variant="success"
                      :value="total_gain"
                      :max="max_progress"
                    />
                  </div>
                  <div class="col-md-2 text-right">
                    <p
                      :class="[
                        'm-0',
                        parseFloat(total_gain) >= 0 ? 'c-success' : 'c-danger',
                      ]"
                    >
                      {{
                        parseFloat(total_gain) >= 0
                          ? formatMoney(String(total_gain))
                          : `${formatMoney(String(total_gain))}`
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <div class="row d-flex align-items-center">
                  <div class="col-md-4">
                    <p class="m-0 worksansr">Total de gastos</p>
                  </div>
                  <div class="col-md-6">
                    <b-progress
                      variant="danger"
                      :value="total_spent"
                      :max="max_progress"
                    />
                  </div>
                  <div class="col-md-2 text-right">
                    <p class="m-0 c-danger">
                      {{ formatMoney(String(total_spent)) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <div class="row d-flex align-items-center">
                  <div class="col-md-4">
                    <p class="m-0 worksansr">Resultado do período</p>
                  </div>
                  <div class="col-md-6">
                    <b-progress
                      variant="success"
                      :value="period_result"
                      :max="max_progress"
                    />
                  </div>
                  <div class="col-md-2 text-right">
                    <p
                      :class="[
                        'm-0',
                        period_result >= 0 && 'c-success',
                        period_result < 0 && 'c-danger',
                      ]"
                    >
                      {{ formatMoney(String(period_result)) }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-0 pb-0">
                <hr class="m-0" />
                <div class="row d-flex align-items-center">
                  <div class="col-md-4">
                    <p
                      class="m-0 worksansr"
                      v-if="dayMonthYear == 'day' && !filter_by_period"
                    >
                      Saldo previsto em {{ moment(month).format("LL") }}
                    </p>
                    <p
                      class="m-0 worksansr"
                      v-if="dayMonthYear == 'month' && !filter_by_period"
                    >
                      Saldo previsto em
                      {{ moment(month).endOf("month").format("LL") }}
                    </p>
                    <p
                      class="m-0 worksansr"
                      v-if="dayMonthYear == 'year' && !filter_by_period"
                    >
                      Saldo previsto em
                      {{ moment(month).endOf("year").format("LL") }}
                    </p>
                    <p class="m-0 worksansr" v-if="filter_by_period">
                      Saldo previsto em
                      {{ moment(end_date).format("LL") }}
                    </p>
                  </div>
                  <div class="col-md-6"></div>
                  <div class="col-md-2 text-right">
                    <p
                      v-if="data.length == 0"
                      :class="['m-0', forecast_balance < 0 && 'c-danger']"
                    >
                      {{ formatMoney(String(forecast_balance)) }}
                    </p>
                    <p
                      v-if="data.length > 0"
                      :class="[
                        'm-0',
                        data[data.length - 1].balance < 0 && 'c-danger',
                      ]"
                    >
                      {{ formatMoney(String(data[data.length - 1].balance)) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import "../../../global/financial/list.css";

import ErrorsMessages from "../../Components/ErrorsMessages";

import Import from "./List/Import";

import SpentPay from "./List/Spent/Pay";

import SpentEdit from "./List/Spent/Edit";

import PendingBilling from "./List/Spent/PendingBilling";

import SpentDetails from "./List/Spent/Details";

import SpentEditTransfer from "./List/Spent/EditTransfer";

import SpentDelete from "./List/Spent/Delete";

import SpentReceipt from "./List/Spent/Receipt";

import SpentDuplicate from "./List/Spent/Duplicate";

import SpentDuplicateTransfer from "./List/Spent/DuplicateTransfer";

import Filters from "./List/Filters";

import ListFilters from "./List/ListFilters";

import BoletoCloud from "./List/BoletoCloud";

import GenerateBoletoInBatch from "./List/GenerateBoletoInBatch";

import PayMultiples from "./List/Spent/PayMultiples";

import DeleteMultiples from "./List/Spent/DeleteMultiples";

import EditMultiples from "./List/Spent/EditMultiples";

import DeleteHosting from "./List/Spent/DeleteHosting";

import DeleteService from "./List/Spent/DeleteService";

import DeleteStockSale from "./List/Spent/DeleteStockSale";

import Attachments from "./List/Spent/Attachments";

import api from "../../../services/api";

import permission from "../../../lib/permission";

import {
  formatMoney,
  formatValueOnKeyUp,
  isNumeric,
  professionalClassCouncilValue,
} from "../../../lib/format";

import { restore, save } from "../../../lib/functions";

import moment from "moment";

import routes from "../../../routes";

moment.locale("pt-br");

export default {
  name: "List",

  components: {
    ErrorsMessages,
    Import,
    SpentPay,
    SpentEdit,
    PendingBilling,
    SpentDetails,
    SpentEditTransfer,
    SpentDelete,
    SpentReceipt,
    SpentDuplicate,
    SpentDuplicateTransfer,
    Filters,
    ListFilters,
    BoletoCloud,
    GenerateBoletoInBatch,
    PayMultiples,
    DeleteMultiples,
    EditMultiples,
    DeleteHosting,
    DeleteService,
    DeleteStockSale,
    Attachments,
  },

  data() {
    return {
      options: {
        page: 1,
      },
      total: 0,
      selected: [],
      itemsSelected: [],
      itemsPaySelected: [],
      finance_launch_bills_to_pay_ids: [],
      btn_selected_type: "add",
      btn_selected_boleto_type: "add",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      json_fields: {
        "Data de vencimento": "due_date",
        Descrição: "description",
        Valor: {
          field: "value",
          callback: (value) => {
            return `R$ ${value}`;
          },
        },
        Categoria: "category",
        "Forma de pagamento":
          "finance_configuration_payment_methods_description",
        "Data de pagamento": "paid_in_date",
        "Cliente/Fornecedor": "client_provider",
        "Centro de custo/lucro":
          "finance_configuration_profit_cost_center_description",
        "Custo nível de produção": "cost_type",
        "Custo apropriação do produto": "cost_appropriation",
        Observação: "note",
        "Tipo de documento": "finance_configuration_document_types_description",
        "Data competência": "competence",
        Conta: "finance_configuration_account_name",
        "Conta que transferiu": "origin_account_name",
        "Conta que recebeu a transferência": "destination_account_name",
      },
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      filter_by_period: false,
      json_data: [],
      search: "",
      search_value: "",
      items: [],
      type: "TODOS",
      cash_competence: "cash",
      data: [],
      dataExportDocument: [],
      balance_date: 0,
      total_gain: 0,
      total_spent: 0,
      period_result: 0,
      forecast_balance: 0,
      previous_balance: 0,
      max_progress: 0,
      month: moment().format("YYYY-MM"),
      month_tmp: moment().format("YYYY-MM"),
      dayMonthYear: "month",
      all_account: true,
      account_ids: [],
      types_of_entries_ids: [],
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],
      users: [],
      providers: [],
      finance_client: [],
      finance_configuration_account: [],
      finance_configuration_document_types: [],
      finance_configuration_payment_methods: [],
      finance_configuration_category: [],
      finance_configuration_category_parents: [],
      finance_configuration_profit_cost_center: [],
      finance_configuration_tag: [],
      showBoletoInBatchModal: false,
      selectedBoletosInBatchIds: [],
      cost_types: [
        { value: "FIXO", description: "FIXO" },
        { value: "VARIAVEL", description: "VARIÁVEL" },
      ],
      cost_appropriations: [
        { value: "DIRETO", description: "DIRETO" },
        { value: "INDIRETO", description: "INDIRETO" },
      ],
      headers: [
        { text: "BOLETO EM LOTE", value: "BoletoBatch", sortable: false },
        { text: "DATA", value: "date", sortable: false },
        { text: "CATEGORIA", value: "categories", sortable: false },
        { text: "Descrição", value: "description", sortable: false },
        // { text: "C.Custo/Lucro", value: "profit_cost_center", sortable: false },
        {
          text: "Cliente/Forn.",
          value: "client_provider",
          sortable: false,
        },
        { text: "VALOR", value: "value", sortable: false, align: "end" },
        { text: "", value: "is_repeat", sortable: false },
        { text: "SALDO", value: "balance", sortable: false, align: "end" },
        { text: "STATUS", value: "status", sortable: false, align: "end" },
        { text: "AÇÃO", value: "action", sortable: false },
      ],
      exist_data: true,
      loading: false,
      loadingActions: false,
      loadingActionToPay: false,
      loadingEdit: false,
      loadingDetails: false,
      loadingDeleteSelected: false,
      loadingDeleteHosting: false,
      loadingExport: false,
      loadingExportDocument: false,
      errors: [],
    };
  },

  computed: {
    selectedBoletosInBatch() {
      return this.data
        .filter((item) => this.selectedBoletosInBatchIds.includes(item.id))
        .map((item) => ({
          id: item.id,
          finance_client_name: item.finance_client_name,
          description: item.description,
          due_date: item.due_date,
          totalCredito: item.totalCredito,
        }));
    },
  },

  created() {
    this.retrieve();
  },

  mounted() {
    this.scroll();
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  methods: {
    moment,
    isNumeric,
    formatMoney,
    formatValueOnKeyUp,
    permission,
    professionalClassCouncilValue,

    async handleExportDataDocument() {
      try {
        this.$bvModal.show("data-export-document");

        this.loadingExportDocument = true;

        let {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          search,
          search_value,
        } = this;

        let page = 1;
        let itemsPerPage = 1000;

        search_value = String(search_value)
          .replace(",", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "");

        if (search_value == "000") {
          search_value = "";
        }

        let params = {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          page,
          itemsPerPage,
          search,
          search_value,
        };

        let response = await api.get(
          "/rest-home/financial/launch/list/document",
          {
            params,
          }
        );

        let { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
          this.dataExportDocument = [];
        } else {
          this.dataExportDocument = data;
          this.errors = [];
        }

        this.loadingExportDocument = false;
      } catch (error) {
        this.loadingExportDocument = false;
        console.log(error);
      }
    },

    handleTextByLimit(string, limit = 12) {
      string = String(string);

      if (string.length > limit) {
        return string.substring(0, limit) + "...";
      }
      return string;
    },

    async handleIdCreate(type) {
      if (type == "finance_configuration_account") {
        await this.financeConfigurationAccount();
      }

      if (type == "finance_configuration_category") {
        await this.financeConfigurationCategory();
      }

      if (type == "provider") {
        await this.provider();
      }

      if (type == "finance_client") {
        await this.financeClient();
      }

      if (type == "finance_configuration_payment_methods") {
        await this.financeConfigurationPaymentMethods();
      }

      if (type == "finance_configuration_profit_cost_center") {
        await this.financeConfigurationProfitCostCenter();
      }

      if (type == "finance_configuration_tag") {
        await this.financeConfigurationTag();
      }

      if (type == "finance_configuration_document_types") {
        await this.financeConfigurationDocumentTypes();
      }
    },

    handleErrorDelete(errors) {
      this.errors = errors;
    },

    async handleExportData() {
      this.loadingExport = true;

      await this.paginateListToExport();

      let items = this.json_data;
      let replacer = (key, value) => (value === null ? "" : value);
      let header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(";")
      );
      csv.unshift(header.join(";"));
      csv = csv.join("\r\n");

      let link = document.createElement("a");

      link.setAttribute(
        "href",
        `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(csv)}`
      );
      link.setAttribute(
        "download",
        `DADOS_DE_LANÇAMENTO_${moment().format("DD/MM/YYYY_HH:mm:ss")}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleSuccessImport() {
      this.financeConfigurationAccount();
      this.paginate();
    },

    handleSuccessAttachments(id) {
      this.$bvModal.hide(`list_attachments_${id}`);
      this.$bvModal.hide(`attachments_${id}`);
      this.paginate();
    },

    handleModalFilterByPeriod() {
      this.$bvModal.show("period");
    },

    handleCancelFilterByPeriod() {
      this.$bvModal.hide("period");
      this.start_date = moment().format("YYYY-MM-DD");
      this.end_date = moment().format("YYYY-MM-DD");
      this.filter_by_period = false;
      this.handlePaginate();
    },

    handleFilterByPeriod() {
      let { start_date, end_date } = this;

      if (!start_date) {
        this.errors = ["Informe a data inicial"];
        return;
      }

      if (!end_date) {
        this.errors = ["Informe a data final"];
        return;
      }

      if (
        parseInt(moment(start_date).format("YYYYMMDD")) >
        parseInt(moment(end_date).format("YYYYMMDD"))
      ) {
        this.errors = ["Informe a data final igual ou maior a data inicial"];
        return;
      }

      this.filter_by_period = true;
      this.handlePaginate();
    },

    handleCancelFilters() {
      this.types_of_entries_ids = [];
      this.users_ids = [];
      this.provider_ids = [];
      this.finance_client_ids = [];
      this.finance_configuration_document_types_ids = [];
      this.finance_configuration_payment_methods_ids = [];
      this.finance_configuration_category_ids = [];
      this.finance_configuration_profit_cost_center_ids = [];
      this.finance_configuration_tag_ids = [];
      this.cost_types_ids = [];
      this.cost_appropriations_ids = [];

      this.$bvModal.hide("filters");
      this.handlePaginate();
    },

    async handleClickRowTable(item) {
      if (item.id) {
        try {
          this.loadingEdit = true;

          let params = { id: item.id };

          const response = await api.get(
            "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
            { params }
          );

          const { data } = response.data;

          this.items = data;

          if (
            item.type == "CONTAS_A_PAGAR" ||
            item.type == "CONTAS_A_RECEBER"
          ) {
            this.$bvModal.show(
              `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
            );
          }

          if (item.type == "TRANSFERENCIA") {
            this.$bvModal.show(
              `edit-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
            );
          }

          this.loadingEdit = false;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async handleModalDelete(item) {
      try {
        this.loadingActions = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.loadingActions = false;
        this.handleDelete(item);
      } catch (error) {
        console.log(error);
      }
    },

    handleSuccessPay() {
      this.$bvModal.hide("pay-selected");
      this.paginate();
    },

    handleCancelPay() {
      this.$bvModal.hide("pay-selected");
    },

    handleSuccessDelete() {
      this.$bvModal.hide("delete-selected");
      this.paginate();
    },

    handleCancelDelete() {
      this.$bvModal.hide("delete-selected");
    },

    handleSuccessEdit() {
      this.$bvModal.hide("edit-selected");
      this.paginate();
    },

    handleCancelEdit() {
      this.$bvModal.hide("edit-selected");
    },

    handleSelected(type) {
      let { data } = this;
      if (type == "add") {
        this.btn_selected_type = "remove";
        for (let item of data) {
          if (item.id && !item.finance_client_resident_id) {
            if (!this.selected.includes(item.id)) {
              if (document.getElementById(`checkbox-${item.id}`)) {
                document.getElementById(`checkbox-${item.id}`).checked = true;
                this.selected.push(item.id);
              }
            }
          }
        }
      }

      if (type == "remove") {
        this.btn_selected_type = "add";
        for (let item of data) {
          if (item.id) {
            if (document.getElementById(`checkbox-${item.id}`)) {
              document.getElementById(`checkbox-${item.id}`).checked = false;
            }
          }
        }
        this.selected = [];
      }
    },

    handleModalSelected(modal) {
      let { selected, data } = this;

      let itemsSelected = [];
      let itemsPaySelected = [];

      for (let item of data) {
        if (selected.includes(item.id)) {
          itemsSelected.push({
            id: item.id,
            finance_launch_bills_to_pay_id: item.finance_launch_bills_to_pay_id,
            date: item.date,
            description: item.description,
            value: item.value,
            is_spent_or_gain: item.is_spent_or_gain,
            is_paid: item.is_paid,
          });

          if (item.is_paid == 0) {
            itemsPaySelected.push({
              id: item.id,
              finance_launch_bills_to_pay_id:
                item.finance_launch_bills_to_pay_id,
              date: item.date,
              description: item.description,
              value: item.value,
              is_spent_or_gain: item.is_spent_or_gain,
              is_paid: item.is_paid,
            });
          }
        }
      }

      this.itemsSelected = itemsSelected;
      this.itemsPaySelected = itemsPaySelected;

      this.$bvModal.show(modal);
    },

    handleChangeSelected(id, item) {
      let { selected } = this;
      if (id) {
        if (!selected.includes(id)) {
          this.selected.push(id);
        }
      } else {
        this.selected = selected.filter((index) => index != item.id);
      }
    },

    async handleModalOption(item) {
      try {
        if (item.fab) {
          return;
        }

        this.loadingActions = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.loadingActions = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalActions(item) {
      try {
        this.loadingActions = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.$bvModal.show(`action-${item.id}`);
        this.loadingActions = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalToPay(item) {
      try {
        this.loadingActionToPay = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.$bvModal.show(`action-pay-${item.id}`);
        this.loadingActionToPay = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalDetails(item) {
      try {
        this.loadingDetails = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.$bvModal.show(
          `details-${item.finance_launch_bills_to_pay_id}-${item.id}`
        );
        this.loadingDetails = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleModalPendingBilling(item) {
      try {
        this.loadingEdit = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;

        this.$bvModal.show(
          `pending-billing-${item.finance_launch_bills_to_pay_id}-${item.id}`
        );

        this.loadingEdit = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleClickCashCompetence(cash_competence) {
      if (this.cash_competence != cash_competence) {
        this.cash_competence = cash_competence;
        this.paginate();
      }
    },

    handleClickListType(type) {
      if (this.type != type) {
        this.type = type;
        this.options.page = 1;
        this.paginate();
      }
    },

    handlePostPendingBilling(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.hide(
        `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.$bvModal.hide(
        `pending-billing-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.handleClickRowTable(item);
      this.paginate();
    },

    handleEdit(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentEdit(item) {
      this.$bvModal.hide(
        `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    async handleSuccessDeleteSpentEdit(item) {
      try {
        this.loadingActions = true;

        let params = { id: item.id };

        const response = await api.get(
          "/rest-home/financial/launch/items-by-finance-launch-bills-to-pay-installments",
          { params }
        );

        const { data } = response.data;

        this.items = data;
        this.loadingActions = false;
        this.$bvModal.show(
          `edit-${item.finance_launch_bills_to_pay_id}-${item.id}`
        );
      } catch (error) {
        console.log(error);
      }
    },

    handleSuccessPendingBilling(item) {
      this.$bvModal.hide(
        `pending-billing-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    handleEditTransfer(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `edit-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentEditTransfer(item) {
      this.$bvModal.hide(
        `edit-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    handleDelete(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `delete-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentDelete(item) {
      this.$bvModal.hide(
        `delete-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    handleReceipt(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `receipt-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentReceipt(item) {
      this.$bvModal.hide(
        `receipt-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleDuplicate(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `duplicate-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentDuplicate(item) {
      this.$bvModal.hide(
        `duplicate-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    handleDuplicateTransfer(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `duplicate-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleSuccessSpentDuplicateTransfer(item) {
      this.$bvModal.hide(
        `duplicate-transfer-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
      this.paginate();
    },

    handleAllAccount(all) {
      let { finance_configuration_account } = this;

      if (all) {
        for (let item of finance_configuration_account) {
          this.account_ids.push(item.id);
        }
        this.all_account = true;
      } else {
        this.account_ids = [];
        this.all_account = false;
      }
    },

    handleAccount() {
      let { account_ids, finance_configuration_account } = this;

      if (finance_configuration_account.length > account_ids.length) {
        this.all_account = false;
      } else {
        this.all_account = true;
      }
    },

    handlePrevMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).subtract(1, "year").format("YYYY");
      }
      this.handlePaginate();
    },

    handleNextMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "days").format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).add(1, "year").format("YYYY");
      }

      this.handlePaginate();
    },

    handleDayMonthYear(dayMonthYear) {
      if (dayMonthYear == this.dayMonthYear) {
        return;
      }

      let { month, month_tmp } = this;

      month_tmp = month;

      this.month = moment(month).format("YYYY-MM-DD");

      if (dayMonthYear == "month") {
        this.month = moment(month_tmp).format("YYYY-MM");
        this.month_tmp = moment(month_tmp).format("YYYY-MM");
      }

      if (dayMonthYear == "year") {
        this.month = moment(month).format("YYYY");
        this.month_tmp = moment(month_tmp).format("YYYY-MM-DD");
      }

      this.dayMonthYear = dayMonthYear;
      this.handlePaginate();
    },

    handleInputMonthTypeYear(year) {
      if (String(year).length == 4) {
        if (isNumeric(year)) {
          this.handlePaginate();
        }
      }
    },

    handleCancelSpentPay(id) {
      this.$bvModal.hide(id);
      let { pay } = routes.history.current.query;

      if (pay) {
        routes.replace({ query: { nav: "releases" } });
      }
    },

    handleSuccessSpentPay(id) {
      this.$bvModal.hide(id);
      this.paginate();
    },

    async retrieve() {
      restore(this, "FinancialLaunchList");

      let { pay, date } = routes.history.current.query;

      if (date) {
        this.dayMonthYear = "day";
        this.month = date;
        this.month_tmp = date;
      }

      await this.financeConfigurationAccount();

      await this.financeConfigurationTag();
      await this.paginate();
      await this.getUsers();
      await this.provider();
      await this.financeClient();
      await this.financeConfigurationPaymentMethods();
      await this.financeConfigurationDocumentTypes();
      await this.financeConfigurationCategory();
      await this.financeConfigurationProfitCostCenter();

      setTimeout(() => {
        if (date) {
          if (pay) {
            this.$bvModal.show(`action-pay-${pay}`);
          }
        }
      }, 1000);
    },

    async getUsers() {
      try {
        const response = await api.get("/rest-home/users-actives");

        const { users } = response.data;

        this.users = users;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationAccount() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/account-actives"
        );

        const { data } = response.data;

        if (this.account_ids.length == 0) {
          for (let item of data) {
            this.account_ids.push(item.id);
          }
        }

        this.finance_configuration_account = data;
      } catch (error) {
        console.log(error);
      }
    },

    async provider() {
      try {
        const params = { active: 1 };
        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },

    async financeClient() {
      try {
        const response = await api.get("/rest-home/financial/client-actives");

        const { data } = response.data;

        this.finance_client = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationPaymentMethods() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives"
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationDocumentTypes() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives"
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        let parents = [];
        let daughters = [];
        for (let item of data) {
          if (item.type == "parent") {
            parents.push(item);
          } else {
            daughters.push(item);
          }
        }

        for (let parent of parents) {
          parent.items = [];
          for (let daughter of daughters) {
            if (daughter.finance_configuration_category_id == parent.id) {
              parent.items.push(daughter);
            }
          }
        }

        this.finance_configuration_category_parents = parents;
        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationProfitCostCenter() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives"
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationTag() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives"
        );

        const { data } = response.data;

        this.finance_configuration_tag = data;
      } catch (error) {
        console.log(error);
      }
    },

    saveState() {
      save(this, "FinancialLaunchList", [
        "type",
        "all_account",
        "account_ids",
        "month",
        "month_tmp",
        "dayMonthYear",
        "types_of_entries_ids",
        "users_ids",
        "provider_ids",
        "finance_client_ids",
        "finance_configuration_document_types_ids",
        "finance_configuration_payment_methods_ids",
        "finance_configuration_category_ids",
        "finance_configuration_profit_cost_center_ids",
        "finance_configuration_tag_ids",
        "cost_types_ids",
        "cost_appropriations_ids",
        "filter_by_period",
        "start_date",
        "end_date",
      ]);
    },

    handlePrint() {
      let {
        type,
        cash_competence,
        month,
        dayMonthYear,
        account_ids,
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
        filter_by_period,
        start_date,
        end_date,
      } = this;

      // if (filter_by_period) {
      //   let startDateMs = moment(start_date).format("x");
      //   let endDateMs = moment(end_date).format("x");
      //   let oneDayMs = 1000 * 60 * 60 * 24;
      //   let diffMs = endDateMs - startDateMs;
      //   let diff = Math.round(diffMs / oneDayMs);

      //   if (parseInt(diff) > 32) {
      //     this.errors = [
      //       "Não pode imprimir dados com período acima de 32 dias",
      //     ];
      //     return;
      //   }
      // }

      let route = this.$router.resolve({
        name: "print-launch-releases",
        params: {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids: account_ids.join(","),
          types_of_entries_ids:
            types_of_entries_ids.length > 0
              ? types_of_entries_ids.join(",")
              : false,
          users_ids: users_ids.length > 0 ? users_ids.join(",") : false,
          provider_ids:
            provider_ids.length > 0 ? provider_ids.join(",") : false,
          finance_client_ids:
            finance_client_ids.length > 0
              ? finance_client_ids.join(",")
              : false,
          finance_configuration_document_types_ids:
            finance_configuration_document_types_ids.length > 0
              ? finance_configuration_document_types_ids.join(",")
              : false,
          finance_configuration_payment_methods_ids:
            finance_configuration_payment_methods_ids.length > 0
              ? finance_configuration_payment_methods_ids.join(",")
              : false,
          finance_configuration_category_ids:
            finance_configuration_category_ids.length > 0
              ? finance_configuration_category_ids.join(",")
              : false,
          finance_configuration_profit_cost_center_ids:
            finance_configuration_profit_cost_center_ids.length > 0
              ? finance_configuration_profit_cost_center_ids.join(",")
              : false,
          finance_configuration_tag_ids:
            finance_configuration_tag_ids.length > 0
              ? finance_configuration_tag_ids.join(",")
              : false,
          cost_types_ids:
            cost_types_ids.length > 0 ? cost_types_ids.join(",") : false,
          cost_appropriations_ids:
            cost_appropriations_ids.length > 0
              ? cost_appropriations_ids.join(",")
              : false,
          filter_by_period,
          start_date,
          end_date,
        },
      });

      window.open(route.href, "_blank");
    },

    handleSuccessFilters(data) {
      let {
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
      } = data;

      this.types_of_entries_ids = types_of_entries_ids;
      this.users_ids = users_ids;
      this.provider_ids = provider_ids;
      this.finance_client_ids = finance_client_ids;
      this.finance_configuration_document_types_ids =
        finance_configuration_document_types_ids;
      this.finance_configuration_payment_methods_ids =
        finance_configuration_payment_methods_ids;
      this.finance_configuration_category_ids =
        finance_configuration_category_ids;
      this.finance_configuration_profit_cost_center_ids =
        finance_configuration_profit_cost_center_ids;
      this.finance_configuration_tag_ids = finance_configuration_tag_ids;
      this.cost_types_ids = cost_types_ids;
      this.cost_appropriations_ids = cost_appropriations_ids;

      this.$bvModal.hide("filters");
      this.paginate();
    },

    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        bottomOfWindow;
      };
    },

    handlePaginate() {
      this.options.page = 1;
      this.paginate();
    },

    handleSearch() {
      this.options.page = 1;
      this.paginate();
    },

    handleSearchValue(value) {
      this.search_value = formatValueOnKeyUp(value);
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        // this.options.page = 1;
        this.$bvModal.hide("import");

        this.loading = true;

        let {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          search,
          search_value,
        } = this;

        const { page, itemsPerPage } = this.options;

        search_value = String(search_value)
          .replace(",", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "");

        if (search_value == "000") {
          search_value = "";
        }

        let params = {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          page,
          itemsPerPage,
          search,
          search_value,
        };

        let response = await api.get("/rest-home/financial/launch/list", {
          params,
        });

        let {
          error,
          errors,
          exist_data,
          data,
          balance_date,
          total_gain,
          total_spent,
          period_result,
          forecast_balance,
          previous_balance,
          max_progress,
          total,
        } = response.data;

        if (error) {
          this.errors = errors;
          this.data = [];
          this.exist_data = false;
        } else {
          this.data = data;
          this.balance_date = balance_date;
          this.total_gain = total_gain;
          this.total_spent = total_spent;
          this.period_result = period_result;
          this.forecast_balance = forecast_balance;
          this.previous_balance = previous_balance;
          this.max_progress = max_progress;
          this.exist_data = exist_data;
          this.total = total;
          if (data.length == 1) {
            this.total = 1;
          }
          this.errors = [];
          let json_data = [];

          this.selected = [];
          this.itemsSelected = [];
          this.btn_selected_type = "add";

          for (let item of data) {
            if (item.id) {
              if (document.getElementById(`checkbox-${item.id}`)) {
                document.getElementById(`checkbox-${item.id}`).checked = false;
              }
            }
          }

          this.$bvModal.hide("account");
          this.$bvModal.hide("profit_cost_center");
          this.$bvModal.hide("period");
          if (exist_data) {
            for (let item of data) {
              if (item.id) {
                let tags = "";

                if (item.finance_configuration_tag_ids) {
                  let finance_configuration_tag_ids = JSON.parse(
                    item.finance_configuration_tag_ids
                  );
                  if (typeof finance_configuration_tag_ids == "object") {
                    if (finance_configuration_tag_ids.length > 0) {
                      for (let tag of this.finance_configuration_tag) {
                        if (finance_configuration_tag_ids.includes(tag.id)) {
                          tags += `${tag.description};`;
                        }
                      }
                    }
                  }
                }

                let obj = {
                  "Data de vencimento": moment(item.due_date).format(
                    "DD/MM/YYYY"
                  ),
                  Descrição: item.description,
                  Valor:
                    item.spent_or_gain == "DEBITO"
                      ? `R$ -${formatValueOnKeyUp(String(item.value))}`
                      : `R$ ${formatValueOnKeyUp(String(item.value))}`,
                  Categoria: item.finance_configuration_category_name
                    ? item.finance_configuration_category_name
                    : "",
                  "Forma de pagamento":
                    item.finance_configuration_payment_methods_description
                      ? item.finance_configuration_payment_methods_description
                      : "",
                  "Data de pagamento":
                    item.is_paid == 1
                      ? item.paid_in_date
                        ? moment(item.paid_in_date).format("DD/MM/YYYY")
                        : ""
                      : "",
                  "Cliente/Fornecedor":
                    item.spent_or_gain == "DEBITO"
                      ? item.provider_company_name
                      : item.finance_client_name,
                  "Centro de custo/lucro":
                    item.finance_configuration_profit_cost_center_description
                      ? item.finance_configuration_profit_cost_center_description
                      : "",
                  "Custo nível de produção": item.cost_type
                    ? item.cost_type
                    : "",
                  "Custo apropriação do produto": item.cost_appropriation
                    ? item.cost_appropriation
                    : "",
                  Observação: item.note ? item.note : "",
                  "Tipo de documento":
                    item.finance_configuration_document_types_description
                      ? item.finance_configuration_document_types_description
                      : "",
                  "Número do documento": item.document_number
                    ? item.document_number
                    : "",
                  "Data competência": moment(item.competence).format(
                    "DD/MM/YYYY"
                  ),
                  Conta: item.finance_configuration_account_name,
                  Tags: tags,
                  "Conta que transferiu":
                    item.type == "TRANSFERENCIA"
                      ? item.origin_account_name
                      : "",
                  "Conta que recebeu a transferência":
                    item.type == "TRANSFERENCIA"
                      ? item.destination_account_name
                      : "",
                };

                if (item.type == "TRANSFERENCIA") {
                  if (item.spent_or_gain == "DEBITO") {
                    json_data.push(obj);
                  }
                } else {
                  json_data.push(obj);
                }
              }
            }
            this.json_data = json_data;
          }
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginateListToExport() {
      try {
        this.loadingExport = true;

        let {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          search,
          search_value,
        } = this;

        let page = 1;
        let itemsPerPage = 5000;

        search_value = String(search_value)
          .replace(",", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "");

        if (search_value == "000") {
          search_value = "";
        }

        let params = {
          type,
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
          page,
          itemsPerPage,
          search,
          search_value,
        };

        let response = await api.get("/rest-home/financial/launch/list", {
          params,
        });

        let { error, exist_data, data } = response.data;

        if (!error) {
          if (exist_data) {
            let json_data = [];

            for (let item of data) {
              if (item.id) {
                let tags = "";

                if (item.finance_configuration_tag_ids) {
                  let finance_configuration_tag_ids = JSON.parse(
                    item.finance_configuration_tag_ids
                  );
                  if (typeof finance_configuration_tag_ids == "object") {
                    if (finance_configuration_tag_ids.length > 0) {
                      for (let tag of this.finance_configuration_tag) {
                        if (finance_configuration_tag_ids.includes(tag.id)) {
                          tags += `${tag.description};`;
                        }
                      }
                    }
                  }
                }

                let obj = {
                  "Data de vencimento": moment(item.due_date).format(
                    "DD/MM/YYYY"
                  ),
                  Descrição: item.description,
                  Valor:
                    item.spent_or_gain == "DEBITO"
                      ? `R$ -${formatValueOnKeyUp(String(item.value))}`
                      : `R$ ${formatValueOnKeyUp(String(item.value))}`,
                  Categoria: item.finance_configuration_category_name
                    ? item.finance_configuration_category_name
                    : "",
                  "Forma de pagamento":
                    item.finance_configuration_payment_methods_description
                      ? item.finance_configuration_payment_methods_description
                      : "",
                  "Data de pagamento":
                    item.is_paid == 1
                      ? item.paid_in_date
                        ? moment(item.paid_in_date).format("DD/MM/YYYY")
                        : ""
                      : "",
                  "Cliente/Fornecedor":
                    item.spent_or_gain == "DEBITO"
                      ? item.provider_company_name
                      : item.finance_client_name,
                  "Centro de custo/lucro":
                    item.finance_configuration_profit_cost_center_description
                      ? item.finance_configuration_profit_cost_center_description
                      : "",
                  "Custo nível de produção": item.cost_type
                    ? item.cost_type
                    : "",
                  "Custo apropriação do produto": item.cost_appropriation
                    ? item.cost_appropriation
                    : "",
                  Observação: item.note ? item.note : "",
                  "Tipo de documento":
                    item.finance_configuration_document_types_description
                      ? item.finance_configuration_document_types_description
                      : "",
                  "Número do documento": item.document_number
                    ? item.document_number
                    : "",
                  "Data competência": moment(item.competence).format(
                    "DD/MM/YYYY"
                  ),
                  Conta: item.finance_configuration_account_name,
                  Tags: tags,
                  "Conta que transferiu":
                    item.type == "TRANSFERENCIA"
                      ? item.origin_account_name
                      : "",
                  "Conta que recebeu a transferência":
                    item.type == "TRANSFERENCIA"
                      ? item.destination_account_name
                      : "",
                };

                if (item.type == "TRANSFERENCIA") {
                  if (item.spent_or_gain == "DEBITO") {
                    json_data.push(obj);
                  }
                } else {
                  json_data.push(obj);
                }
              }
            }
            this.json_data = json_data;
          }
        }

        this.loadingExport = false;
      } catch (error) {
        this.loadingExport = false;
        console.log(error);
      }
    },

    handleSelectedBoletoInBatch(type) {
      if (type == "add") {
        this.btn_selected_boleto_type = "remove";

        this.selectedBoletosInBatchIds = this.data
          .filter(
            (item) => item.id && item.finance_client_id && item.boleto == 0
          )
          .map((item) => item.id);
      }

      if (type == "remove") {
        this.btn_selected_boleto_type = "add";

        this.selectedBoletosInBatchIds = [];
      }
    },

    modalCloseBoletoInBatch() {
      this.showBoletoInBatchModal = false;

      this.selectedBoletosInBatchIds = [];
    },
  },
};
</script>

<style>
.v-data-table-finance .v-data-table-header tr th span {
  font-size: 10px;
  color: #000;
}
</style>